export default __webpack_public_path__ + "6b1af66b615ecef9995011b9ba4fb08c.png";